<app-loading *ngIf="contentReady"></app-loading>

<div
  class="bbm-page"
  [class.rtl]="isAr"
  [dir]="isAr ? 'rtl' : 'ltr'"
>
  <div class="bbm-shell">

    <!-- HERO -->
    <section class="bbm-hero">

      <div class="bbm-hero-top">

        <div class="bbm-main-info">

          <div class="bbm-avatar">
            <i
              class="fa-solid fa-paw"
              aria-hidden="true"
            ></i>
          </div>

          <div class="bbm-hero-copy">
            <span class="bbm-eyebrow">
              {{ 'allServicesMobile.header.badge' | transloco }}
            </span>

            <h2>
              {{ 'allServicesMobile.header.title' | transloco }}
            </h2>

            <p>
              {{ 'allServicesMobile.header.subtitle' | transloco }}
            </p>
          </div>

        </div>

      </div>

      @if (!isStockTaking) {
        @if (isAdmin || isSubAdmin) {
          <div class="bbm-actions-grid bbm-hero-actions noPrint">
            <button
              type="button"
              routerLink="/AddService"
              class="
                bbm-action-btn
                bbm-action-primary
                bbm-action-wide
              "
            >
              <i
                class="fa-solid fa-plus"
                aria-hidden="true"
              ></i>

              <span>
                {{ 'allServicesMobile.actions.addService' | transloco }}
              </span>
            </button>
          </div>
        }
      }

    </section>

    <!-- SEARCH -->
    <section class="bbm-form-ticket">

      <div class="bbm-form-head">
        <div>
          <span class="bbm-eyebrow">
            {{ 'allServicesMobile.actions.search' | transloco }}
          </span>

          <h3>
            {{ 'allServicesMobile.header.title' | transloco }}
          </h3>
        </div>
      </div>

      <div class="bbm-search-control">
        <i
          class="fa-solid fa-magnifying-glass"
          aria-hidden="true"
        ></i>

        <input
          type="text"
          class="bbm-control"
          [(ngModel)]="searchKey"
          [placeholder]="
            'allServicesMobile.search.placeholder'
              | transloco
          "
          (keydown.enter)="onEnterPressed()"
        />
      </div>

      <div class="bbm-actions-grid">

        <button
          type="button"
          class="bbm-action-btn bbm-action-primary"
          (click)="search()"
        >
          <i
            class="fa-solid fa-magnifying-glass"
            aria-hidden="true"
          ></i>

          <span>
            {{ 'allServicesMobile.actions.search' | transloco }}
          </span>
        </button>

        <button
          *ngIf="searched"
          type="button"
          class="bbm-action-btn bbm-action-danger"
          (click)="clearSearch()"
        >
          <i
            class="fa-solid fa-rotate-left"
            aria-hidden="true"
          ></i>

          <span>
            {{ 'allServicesMobile.actions.allData' | transloco }}
          </span>
        </button>

      </div>

    </section>

    <!-- SUMMARY -->
    <section
      class="bbm-list-head"
      *ngIf="!noData"
    >
      <div>
        <span>
          {{ 'allServicesMobile.summary.servicesShown' | transloco }}
        </span>

        <h3>
          {{ allData.length }}
          /
          {{ totalItems }}
        </h3>
      </div>

      <span
        *ngIf="searched"
        class="bbm-status-pill bbm-status-primary"
      >
        <i
          class="fa-solid fa-magnifying-glass"
          aria-hidden="true"
        ></i>

        {{ 'allServicesMobile.summary.searchMode' | transloco }}
      </span>
    </section>

    <!-- SERVICES CARDS -->
    <section
      class="bbm-ticket-list"
      *ngIf="!noData"
    >
      <article
        class="bbm-ticket"
        *ngFor="let item of allData"
      >

        <!-- SERVICE TOP -->
        <div class="bbm-ticket-top">

          <div class="bbm-main-info">

            <div
              class="bbm-avatar bbm-avatar-contain"
              *ngIf="item.image; else noImage"
            >
              <img
                [src]="fixImage(item.image)"
                [alt]="isAr ? item.name_ar : item.name_en"
                (error)="onImageError($event)"
              />
            </div>

            <ng-template #noImage>
              <div class="bbm-avatar">
                <i
                  class="fa-solid fa-paw"
                  aria-hidden="true"
                ></i>
              </div>
            </ng-template>

            <div class="bbm-copy">
              <span>
                {{ 'allServicesMobile.header.badge' | transloco }}
              </span>

              <h3>
                {{ isAr ? item.name_ar : item.name_en }}
              </h3>

              <p *ngIf="item.barcode">
                <i
                  class="fa-solid fa-barcode"
                  aria-hidden="true"
                ></i>

                <span>
                  {{ item.barcode }}
                </span>
              </p>
            </div>

          </div>

          <button
            type="button"
            class="bbm-action-btn bbm-icon-action"
            [class.bbm-action-primary]="!isInCart(item)"
            [class.bbm-action-success]="isInCart(item)"
            (click)="addToCart(item)"
          >
            <i
              class="fa-solid"
              [class.fa-cart-plus]="!isInCart(item)"
              [class.fa-cart-shopping]="isInCart(item)"
              aria-hidden="true"
            ></i>
          </button>

        </div>

        <!-- SERVICE INFORMATION -->
        <div class="bbm-badges-row">

          <span class="bbm-badge">
            <i
              class="fa-solid fa-dog"
              aria-hidden="true"
            ></i>

            {{ getPetKey(item.pet) | transloco }}
          </span>

          <span class="bbm-badge bbm-badge-dark">
            <i
              class="fa-solid fa-tag"
              aria-hidden="true"
            ></i>

            {{ getPetTypeKey(item.pet_type) | transloco }}
          </span>

        </div>

        <!-- PRICES -->
        <div
          class="
            bbm-details-grid
            bbm-summary-grid
            bbm-ticket-section
          "
        >

          @if (isAdmin || isSuperAdmin || isSubAdmin) {
            <div class="bbm-detail-chip">
              <i
                class="fa-solid fa-coins"
                aria-hidden="true"
              ></i>

              <span>
                {{ 'allServicesMobile.labels.costPrice' | transloco }}
              </span>

              <strong class="bbm-money-value">
                {{ item.price || 0 }}
              </strong>
            </div>
          }

          <div
            class="bbm-detail-chip bbm-detail-success"
            [class.bbm-detail-wide]="
              !(isAdmin || isSuperAdmin || isSubAdmin)
            "
          >
            <i
              class="fa-solid fa-money-bill-wave"
              aria-hidden="true"
            ></i>

            <span>
              {{ 'allServicesMobile.labels.sellingPrice' | transloco }}
            </span>

            <strong class="bbm-money-value">
              {{ item.pricea || 0 }}
            </strong>
          </div>

        </div>

        <!-- ACTIONS -->
        <div
          class="
            bbm-actions-grid
            bbm-ticket-section
          "
          [class.bbm-actions-three]="
            (isAdmin || isSuperAdmin) && !isSubAdmin
          "
        >

          <button
            type="button"
            class="bbm-action-btn"
            [class.bbm-action-success]="!isInCart(item)"
            [class.bbm-action-danger]="isInCart(item)"
            [class.bbm-action-wide]="
              !((isAdmin || isSuperAdmin) && !isSubAdmin)
            "
            (click)="addToCart(item)"
          >
            <i
              class="fa-solid"
              [class.fa-plus]="!isInCart(item)"
              [class.fa-minus]="isInCart(item)"
              aria-hidden="true"
            ></i>

            <span>
              {{
                isInCart(item)
                  ? (
                      'allServicesMobile.actions.removeFromCart'
                        | transloco
                    )
                  : (
                      'allServicesMobile.actions.addToCart'
                        | transloco
                    )
              }}
            </span>
          </button>

          @if ((isAdmin || isSuperAdmin) && !isSubAdmin) {
            <button
              type="button"
              class="bbm-action-btn bbm-action-warning"
              (click)="edit(item)"
            >
              <i
                class="fa-solid fa-pen"
                aria-hidden="true"
              ></i>

              <span>
                {{ 'allServicesMobile.actions.edit' | transloco }}
              </span>
            </button>

            <button
              type="button"
              class="bbm-action-btn bbm-action-danger"
              (click)="deleteitem(item.id)"
            >
              <i
                class="fa-solid fa-trash"
                aria-hidden="true"
              ></i>

              <span>
                {{ 'allServicesMobile.actions.delete' | transloco }}
              </span>
            </button>
          }

        </div>

      </article>
    </section>

    <!-- LOAD MORE LOADER -->
    <div
      class="bbm-loader"
      *ngIf="loadingMore"
    >
      <span
        class="bbm-loader-spinner"
        aria-hidden="true"
      ></span>

      <span>
        {{ 'allServicesMobile.summary.loadingMore' | transloco }}
      </span>
    </div>

    <!-- END MESSAGE -->
    <div
      class="bbm-end-state"
      *ngIf="!noData && !hasMore && allData.length > 0"
    >
      {{ 'allServicesMobile.summary.noMoreData' | transloco }}
    </div>

    <!-- NO DATA -->
    <div
      class="bbm-empty-state"
      *ngIf="noData && !contentReady"
    >
      <app-nodata></app-nodata>
    </div>

  </div>
</div>

<!-- FLOATING CART -->
@if (cartItemCount > 0) {
  <button
    type="button"
    class="bbm-floating-action noPrint"
    (click)="cartPopUpOpen()"
  >
    <span class="bbm-badge">
      {{ cartItemCount }}
    </span>

    <i
      class="fa-solid fa-cart-shopping"
      aria-hidden="true"
    ></i>

    <span>
      {{ 'allServicesMobile.cart.title' | transloco }}
    </span>
  </button>
}

<!-- CART POPUP -->
<div
  *ngIf="cartPopUp"
  class="bbm-modal-backdrop noPrint"
  [class.rtl]="isAr"
  [dir]="isAr ? 'rtl' : 'ltr'"
>
  <section
    class="bbm-modal-card"
    role="dialog"
    aria-modal="true"
  >

    <div class="bbm-modal-handle"></div>

    <!-- POPUP HEADER -->
    <div class="bbm-form-head">

      <div class="bbm-main-info">

        <div class="bbm-avatar">
          <i
            class="fa-solid fa-cart-shopping"
            aria-hidden="true"
          ></i>
        </div>

        <div>
          <span class="bbm-eyebrow">
            {{ 'allServicesMobile.cart.selectedServices' | transloco }}
          </span>

          <h3>
            {{ 'allServicesMobile.cart.title' | transloco }}
          </h3>
        </div>

      </div>

      <button
        type="button"
        class="
          bbm-action-btn
          bbm-action-danger
          bbm-icon-action
        "
        (click)="close()"
      >
        <i
          class="fa-solid fa-xmark"
          aria-hidden="true"
        ></i>
      </button>

    </div>

    <!-- CART COUNT -->
    <div class="bbm-alert bbm-alert-primary">
      <i
        class="fa-solid fa-layer-group"
        aria-hidden="true"
      ></i>

      <span>
        <strong>{{ cartItemCount }}</strong>
        {{ 'allServicesMobile.cart.selectedServices' | transloco }}
      </span>
    </div>

    <!-- CART ITEMS -->
    <div class="bbm-modal-list">

      <div class="bbm-products-list">

        <div
          *ngFor="let item of cartItems"
          class="bbm-product-row"
        >
          <div class="bbm-product-name">
            {{ isAr ? item.name_ar : item.name_en }}

            (
            {{
              item.cartItemType === 'service' ||
              (
                !item.cartItemType &&
                item.quantity === undefined
              )
                ? ('Service' | transloco)
                : ('Product' | transloco)
            }}
            )
          </div>

          <button
            type="button"
            class="
              bbm-action-btn
              bbm-action-danger
              bbm-icon-action
            "
            (click)="removeFromCart(item)"
          >
            <i
              class="fa-solid fa-trash"
              aria-hidden="true"
            ></i>
          </button>
        </div>

      </div>

    </div>

    <!-- CART ACTIONS -->
    <div class="bbm-form-actions">

      <button
        type="button"
        class="bbm-action-btn bbm-action-success"
        (click)="quickOrder()"
      >
        <i
          class="fa-solid fa-arrow-right"
          aria-hidden="true"
        ></i>

        <span>
          {{ 'allServicesMobile.actions.proceedToOrder' | transloco }}
        </span>
      </button>

      <button
        type="button"
        class="bbm-action-btn bbm-action-danger"
        (click)="close()"
      >
        <i
          class="fa-solid fa-xmark"
          aria-hidden="true"
        ></i>

        <span>
          {{ 'allServicesMobile.actions.close' | transloco }}
        </span>
      </button>

    </div>

  </section>
</div>